module.exports = __webpack_public_path__ + "img/partner-kpwa.8a33f841.png";